import React from 'react';
import { getTheme } from '@uifabric/styling';
import { Stack } from 'office-ui-fabric-react';
import { formatDate } from 'buzz_lib_shared';
import { DatePicker } from '../DatePicker';
import { FieldErrorMessage } from '../Validation/FieldErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateRangePicker = props => {
  var _props$datePickerFrom, _props$datePickerFrom2, _props$datePickerTo, _props$datePickerTo2;
  const datePickerStyles = {
    iconProps: {
      styles: {
        root: {
          color: getTheme().palette.themePrimary
        }
      }
    },
    styles: {
      field: {
        color: getTheme().palette.themePrimary
      }
    }
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "start",
      tokens: {
        childrenGap: 15
      },
      children: [/*#__PURE__*/_jsx(DatePicker, {
        onSelectDate: date => date && props.onDateFromChange(date),
        textField: datePickerStyles,
        minDate: props.minDateFrom,
        maxDate: props.maxDateFrom,
        value: props.dateFromValue,
        formatDate: formatDate,
        placeholder: props.dateFromPlaceholder || 'Select date from',
        disabled: props.isDisabled,
        "data-id": props.dateFromDataId,
        styles: props.datePickerStyles,
        initialPickerDate: (_props$datePickerFrom = props.datePickerFrom) === null || _props$datePickerFrom === void 0 ? void 0 : _props$datePickerFrom.initialDate,
        label: (_props$datePickerFrom2 = props.datePickerFrom) === null || _props$datePickerFrom2 === void 0 ? void 0 : _props$datePickerFrom2.label
      }), /*#__PURE__*/_jsx(DatePicker, {
        onSelectDate: date => date && props.onDateToChange(date),
        textField: datePickerStyles,
        minDate: props.minDateTo,
        maxDate: props.maxDateTo,
        value: props.dateToValue,
        formatDate: formatDate,
        placeholder: props.dateToPlaceholder || 'Select date to',
        disabled: props.isDisabled,
        "data-id": props.dateToDataId,
        styles: props.datePickerStyles,
        initialPickerDate: (_props$datePickerTo = props.datePickerTo) === null || _props$datePickerTo === void 0 ? void 0 : _props$datePickerTo.initialDate,
        label: (_props$datePickerTo2 = props.datePickerTo) === null || _props$datePickerTo2 === void 0 ? void 0 : _props$datePickerTo2.label
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      children: props.errorMessage && /*#__PURE__*/_jsx(FieldErrorMessage, {
        children: props.errorMessage
      })
    })]
  });
};